module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "k1_upright",
    class: [{
        disabled: _vm.compIsDisabled
      },
      {
        firstUpper: _vm.compData.firstUpper
      },
      {
        secondUpper: _vm.compData.secondUpper
      },
      {
        selectable: _vm.compIsSelectable
      },
      _vm.compData.height
    ],
    style: ({
      height: _vm.px(_vm.compHeight),
      width: _vm.px(_vm.compWidth)
    })
  }, [_c('div', {
    staticClass: "k1_container"
  }, [_vm._t("default"), _vm._v(" "), _c('edituprightbtn', {
    attrs: {
      "is-visible": _vm.compShowEdit
    },
    on: {
      "click": function($event) {
        _vm.emitOnEdit()
      }
    }
  }), _vm._v(" "), _c('checkbtn', {
    attrs: {
      "is-visible": _vm.compIsSelectable,
      "is-checked": _vm.compIsSelected
    },
    on: {
      "click": _vm.emitOnSelect
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "k1_width h8"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.compWidth) + " CM\n\t\t")])], 2), _vm._v(" "), _c('adduprightbtn', {
    attrs: {
      "is-visible": _vm.showAdd
    },
    on: {
      "click": function($event) {
        _vm.emitOnAdd()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f3e042a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/K1Upright.vue
// module id = 652
// module chunks = 0